import dynamic from 'next/dynamic'

export const DynamicGuestAddressModal = dynamic(
  () => import('.').then((mod) => mod.GuestAddressModal),
  { ssr: false },
)
